import RepeatIcon from '@/common/assets/icons/repeat-Icon.svg?react';
import Button from '@/common/components/base/button/Button';
import MainModal from '@/common/components/base/modal/Modal';
import { MainModalProps } from '@/common/components/base/modal/Modal.type';
import Typography from '@/common/components/base/typography/Typography';
import { Flex } from 'styled-system/jsx';

type RepeatCapturingModalProps = {
  repeatCapturing: () => void;
};

export default ({
  closeModal,
  open,
  repeatCapturing,
}: MainModalProps & RepeatCapturingModalProps) => {
  return (
    <MainModal closeModal={closeModal} open={open}>
      <RepeatCapturingModal
        closeModal={closeModal}
        repeatCapturing={repeatCapturing}
      />
    </MainModal>
  );
};
const RepeatCapturingModal = ({
  repeatCapturing,
  closeModal,
}: Partial<MainModalProps> & RepeatCapturingModalProps) => {
  return (
    <Flex flexDir="column" alignItems="center" justifyContent="center">
      <Flex flexDir="column" alignItems="center" gap={23}>
        <RepeatIcon />
        <Typography textStyle="b1" color="black-1">
          آیا از عکس برداری مجدد مطمئن هستید؟
        </Typography>
        <Typography textStyle="b2" color="black-3">
          در این صورت کلیه عکس های ذخیره شده پاک خواهند شد
        </Typography>
      </Flex>
      <Flex gap={16} mt={40} w="100%">
        <Button
          fullWidth
          variant="outlined"
          color="common"
          onClick={closeModal}
        >
          انصراف
        </Button>
        <Button
          fullWidth
          variant="contained"
          color="danger"
          onClick={repeatCapturing}
        >
          عکس برداری مجدد
        </Button>
      </Flex>
    </Flex>
  );
};
